import _ from 'lodash';
import React, { Component } from 'react';
import BarItem from './barItem.jsx';
import Shadow from './shadow.jsx';
import numeral from 'numeral';

// Sample props =>
// {
//   lhs: [
//     {
//       name: 'Overall Segment Size',
//       value: 538270,
//     },
//     {
//       name: 'Sent',
//       value: 494573,
//     },
//     {
//       name: 'Delivered',
//       value: 340000,
//     },
//   ],
//     rhs: {
//   name: 'Deliverability Rate',
//     value: 90.25,
//     description: 'This is description',
// },
//   width: 200,
//     height: 300,
//   barColor: '#00B14F',
//   shadowColor: '#E5FAEC',
//   barDiffColor: '#f5f5f5',
// }

type Props = {
  lhs: Array<Object>,
  rhs: Object,
  height?: number,
  barColor?: string,
  shadowColor?: string,
  barDiffColor?: string,
};

export default class EquationBarGraph extends Component {
  static defaultProps = {
    height: 300,
    barColor: '#00B14F',
    shadowColor: '#E5FAEC',
    barDiffColor: '#f5f5f5',
  };

  getUpdatedLHSMeta(equationBarGraphMeta: Props) {
    const lhs = equationBarGraphMeta.lhs;
    for (let index = 0; index < lhs.length; index++) {
      if (index === 0) {
        lhs[index].height = equationBarGraphMeta.height;
      } else {
        lhs[index].height =
          lhs[index].value / lhs[0].value * equationBarGraphMeta.height;
        lhs[index].shadowValue =
          (lhs[index].value - lhs[index - 1].value) / lhs[index - 1].value;
      }
    }
    return lhs;
  }

  getUpdatedRHSMeta(equationBarGraphMeta: Props) {
    const rhs = equationBarGraphMeta.rhs;
    rhs.height =
      equationBarGraphMeta.height * equationBarGraphMeta.rhs.value / 100;
    return rhs;
  }

  getBarItemWidth(equationBarGraphMeta: Props) {
    const barItems = equationBarGraphMeta.lhs.length + 1;
    const totalBarWidth = 65;
    return totalBarWidth / barItems;
  }

  getShadowWidth(equationBarGraphMeta: Props) {
    const barItems = equationBarGraphMeta.lhs.length + 1;
    const totalShadowWidth = 35;
    return totalShadowWidth / (barItems - 1);
  }

  constructor(props: Props) {
    super(props);
    this.state = {
      key: 1,
      barItemWidth: this.getBarItemWidth(props),
      shadowWidth: this.getShadowWidth(props),
      lhs: this.getUpdatedLHSMeta(props),
      rhs: this.getUpdatedRHSMeta(props),
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!_.isEqual(this.props, nextProps)) {
      this.setState({
        key: this.state.key + 1,
        barItemWidth: this.getBarItemWidth(nextProps),
        shadowWidth: this.getShadowWidth(nextProps),
        lhs: this.getUpdatedLHSMeta(nextProps),
        rhs: this.getUpdatedRHSMeta(nextProps),
      });
    }
  }

  render() {
    return (
      <div
        key={this.state.key}
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'end',
        }}
      >
        <React.Fragment>
          {this.state.lhs.map((item, index) => (
            <React.Fragment>
              {index !== 0 && (
                <Shadow
                  value={item.shadowValue}
                  color={this.props.shadowColor}
                  width={this.state.shadowWidth}
                  height={item.height}
                  totalHeight={this.state.lhs[index - 1].height}
                />
              )}
              <BarItem
                name={item.name}
                value={item.value}
                height={item.height}
                totalHeight={this.props.height}
                width={this.state.barItemWidth}
                color={this.props.barColor}
                shadowColor={this.props.barDiffColor}
                targetValue={numeral(item.value).format('0,0')}
                description={item.description}
              />
            </React.Fragment>
          ))}
          <div
            style={{
              width: `${this.state.shadowWidth}%`,
              height: `${this.state.rhs.height}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div>
              <div
                style={{
                  height: '2px',
                  width: '13px',
                  backgroundColor: '#1A1A1A',
                }}
              />
              <div
                style={{
                  height: '2px',
                  width: '13px',
                  marginTop: '3px',
                  backgroundColor: '#1A1A1A',
                }}
              />
            </div>
          </div>
          <BarItem
            name={this.state.rhs.name}
            value={this.state.rhs.value}
            totalHeight={this.props.height}
            height={this.state.rhs.height}
            width={this.state.barItemWidth}
            color={this.props.barColor}
            shadowColor={this.props.barDiffColor}
            targetValue={numeral(this.state.rhs.value / 100).format('0%')}
            description={this.state.rhs.description}
          />
        </React.Fragment>
      </div>
    );
  }
}
